export const text =
`
I wrote a book called the Spiritstone Chronicals
`
